export const sanitizeFileSegment = (value) =>
  (value ?? "")
    .toString()
    .trim()
    .replace(/[/\\?%*:|"<>]/g, "-")
    .replace(/\s+/g, "-");

export const getLedgerExportFileName = ({
  tabLabel,
  matterRef,
  isAllTab = false,
}) => {
  const ref = sanitizeFileSegment(matterRef) || "Ledger";

  if (isAllTab || !tabLabel || tabLabel === "All") {
    return ref;
  }

  return `${sanitizeFileSegment(tabLabel)}-${ref}`;
};
